// extracted by mini-css-extract-plugin
export default {"navigationContainer":"footer-links-module__navigationContainer--WDmUS","link":"footer-links-module__link--y4nfV"};